import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import LayerControl from "@/components/layer/LayerControl";
import { selectCurrentLayerGroup } from "@/selector";
import { actionCreators as timelineActionCreators } from "@/duck/timeline";
import { actionCreators } from "@/duck/panel";

const ConcentrationLayerControl = ({ layerGroup, toggleLayer }) => {
  const { t } = useTranslation();
  const currentLayerGroup = useSelector(selectCurrentLayerGroup);
  const groupName = "concentration";
  const dispatch = useDispatch();
  const settingLayer = useCallback(() => {
    dispatch(actionCreators.panel.temperature.reset());
    dispatch(
      timelineActionCreators.timeline.show({ currentLayerGroup: groupName })
    );
  }, [dispatch, groupName]);
  return (
    <LayerControl
      name={t("data.concentration")}
      groupName={groupName}
      isCurrent={currentLayerGroup === "concentration"}
      isShow={layerGroup.includes("concentration")}
      toggleLayer={toggleLayer}
      settingLayer={settingLayer}
    ></LayerControl>
  );
};

export default ConcentrationLayerControl;
